const apiURL = 'https://api.tickets.acras.au/'
//const apiURL = 'http://localhost:8000/'
const variables = {
    apiURL
};
  
export default variables;